import $ from 'jquery';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';
import { fetchEditorTemplateById } from '~graphql/controllers';
import { getState, modifyState } from '~src/state';
import { composeMetadataCanvasNavText } from '~loader/loader-utils';
import { TextTemplate } from '@onoranzefunebricloud/giotto-text-template';
import { onErrorShowMessage } from '~src/errors';
import { applyOrgLogosOnCurrentPage } from '~src/sidebar/logo';
import { addPagesToSidebar } from '~src/multipages';
import { setProfilePhotoToAllMagicFrames } from '~src/utils';
import { handleTabAnnunciFunebri } from '~src/sidebar/index';
import { v4 as uuidv4 } from 'uuid';
import { updateUndoRedoControls, replaceImageUrlsWithImage } from '~core';
import { onTemplateCordogliChange } from '~src/sidebar/annunciFunebri/onTemplateCordogliChange';
import { editorConfig } from '~config';
import { getTextTemplateContext } from '../utils';
import addServiceReservationImagesToCanvas from '../utils/addServiceReservationImagesToCanvas';
import { processCanvasObjects } from '~core/templates';
import { convertTextboxesToSpellCheck, checkSpelling } from '~core/spellcheck';
import { saveEditorState } from '~core/saveEditorState';
import { goToPage } from '~src/multipages/goToPage';
import { generateCurrentPageThumbnail } from '~src/multipages/generateCurrentPageThumbnail';

export const onTemplateChange = async (event) => {
  event.preventDefault();

  if (getState('isLoading.canvas') || !window.canvas) {
    return;
  }

  modifyState('isLoading.canvas', true);
  const id = $(event.currentTarget).data('templates-item-id');
  const isGlobal = $(event.currentTarget).data('templates-item-is-global');

  const currentPageIndex = getState('currentPageIndex');

  // Navigate to first page before applying template
  if (currentPageIndex !== 0) {
    await goToPage(0);
  }

  const currentHistoryIndex = getState(`currentHistoryIndex[${0}]`);

  if (currentHistoryIndex >= 1 && window.canvas.getObjects().length != 0) {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Sei sicuro?',
      text:
        'Applicando questo modello perderai le tue attuali modifiche definitivamente.',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonText: 'Annulla',
      confirmButtonText: 'Si, applica modello e perdi modifiche',
    });

    if (result.isDismissed) {
      modifyState('isLoading.canvas', false);
      return false;
    }
    modifyState(`history[${0}]`, []);
    modifyState(`currentHistoryIndex[${0}]`, 0);
    modifyState('totalChangesSinceLastSave', 0);
  }

  $('.canvas-container').hide();
  $('.app-spinner').show();

  const template = await fetchEditorTemplateById(id, isGlobal);

  const editorMode = getState('editorMode');

  let pages =
    template.isGlobal && template.isGlobal === true
      ? template.editor_templates_default_pages
      : template.editor_templates_pages;

  pages = _.sortBy(pages, ['order']);

  const projectType = getState('selected.tipo');
  const isCordogli = editorConfig.cordogliProjectIds.includes(
    projectType.objectId
  );
  const currentPages = getState('pages', []);

  if (!isCordogli && currentPages.length > pages.length) {
    onErrorShowMessage(false, {
      icon: 'warning',
      title: 'Oops',
      text:
        'Questa funzionalità non è disponibile poiché il numero di pagine del progetto non coincide con il numero di pagine del modello.',
    });
    $('.canvas-container').show();
    $('.app-spinner').hide();
    return false;
  }

  const templateCategory = template.editor_templates_categories_default_pointer
    ? template.editor_templates_categories_default_pointer
    : template.editor_templates_categories_pointer;

  modifyState('selected.templatesCategory', templateCategory);

  for (let i = 0; i < pages.length; i++) {
    if (!currentPages[i]) {
      currentPages[i] = {};
    }
    if (pages[i].canvasJson) {
      currentPages[i].canvasJson = pages[i].canvasJson;
    } else {
      currentPages[i].canvasJson = JSON.stringify({
        objects: [],
        background: '#ffffff',
      });
    }
    currentPages[i].temporaryId = uuidv4();
    currentPages[i].order = pages[i].order;
    currentPages[i].preview = pages[i].preview;
    currentPages[i].preview.__type = 'File'; // Required to allow saving preview via PUT in lambda-parse-api
    if (pages[i].animations) {
      currentPages[i].animations = JSON.parse(pages[i].animations);
    }
  }

  // Clear old thumbnails to force regeneration with new template content
  for (const page of currentPages) {
    delete page.imgData;
  }

  await modifyState('pages', currentPages);

  const {
    servizio,
    user,
    deleganti,
    necrofori,
    card,
    serviceReservation,
  } = await getTextTemplateContext();

  const textTemplate = new TextTemplate(
    servizio,
    user,
    deleganti,
    necrofori,
    card,
    serviceReservation
  );

  if (Object.keys(serviceReservation).length > 0) {
    console.debug(
      'TextTemplate debug for service reservation variables',
      textTemplate
    );
  }

  // Questo IF skippa il render delle variabili con Mustache
  // Per permetterci di lavorare ai templates.
  if (editorMode === EDITOR_MODE_DEFAULT && servizio) {
    for (const page of currentPages) {
      // we re-calculate the styles based on the actual variable values (otherwise the bold, italic etc are applied to the string randomly based on the length of the variable itself instead of the actual value)
      page.canvasJson = processCanvasObjects(
        page.canvasJson,
        textTemplate.getContext()
      );
      // Then render the variables with Mustache
      page.canvasJson = textTemplate.renderMustache(page.canvasJson);
    }
  }

  if (templateCategory && templateCategory.annunciFunebri) {
    $('#btn-sidebar-annuncio-funebre').removeClass('d-none');
    $('#btn-sidebar-annuncio-funebre').click(handleTabAnnunciFunebri);
  } else {
    $('#btn-sidebar-annuncio-funebre').addClass('d-none');
    $('#btn-sidebar-annuncio-funebre').unbind('click', handleTabAnnunciFunebri);
  }

  const canvasJson = getState('pages[0].canvasJson', '');

  modifyState('pauseCanvasHistory', true);

  window.canvas.loadFromJSON(canvasJson, async () => {
    await convertTextboxesToSpellCheck(window.canvas);

    applyOrgLogosOnCurrentPage();
    window.canvas.renderAll();
    await setProfilePhotoToAllMagicFrames();
    await replaceImageUrlsWithImage();
    await addServiceReservationImagesToCanvas();
    modifyState('pauseCanvasHistory', false);

    // Generate thumbnail for the current page (page 0) after template is loaded
    await generateCurrentPageThumbnail();

    addPagesToSidebar();
    composeMetadataCanvasNavText();
    updateUndoRedoControls();
    if (isCordogli) {
      try {
        await onTemplateCordogliChange();
      } catch (err) {
        console.error(err);
        onErrorShowMessage();
      }
    }
    $('.canvas-container').show();
    $('.app-spinner').hide();
    modifyState('isLoading.canvas', false);

    // Check spelling for all textboxes after template load
    try {
      await checkSpelling(window.canvas);
    } catch (error) {
      console.error('Error checking spelling after template change:', error);
    }

    // Save the project after template change
    try {
      await saveEditorState(true, true);
    } catch (error) {
      console.error('Error saving project after template change:', error);
    }
  });
};
